import { createContext } from "react";
import type { ModalContextType } from "./types";

const invariantViolation = () => {
  throw new Error(
    "Attempted to call useModal outside of modal context. Make sure your app is rendered inside ModalProvider."
  );
};

export const ModalContext = createContext<ModalContextType>({
  onOpenModal: invariantViolation,
  onCloseModal: invariantViolation,
});
